export const isValidReturnUrl = (url: string) => {
  // Ensure it starts with a slash and is not a full URL with a protocol (http/https)
  return url && url.startsWith('/') && !url.startsWith('//');
};
